import { FC, useEffect, useState } from 'react'
import { Form } from 'antd'
import useRequest from '../../../../../hooks/useRequest'
import { getCalculatorTariffs } from '../../configurations'
export const operationOptions = [
    { value: 'Внесение записи о предоставлении сертификата', id: 15 },
    { value: 'Внесение записи о передаче сертификата другому лицу', id: 29 },
    { value: 'Внесение записи о погашении сертификата', id: 30 },
    {
        value: 'Внесение записи о передаче атрибутов генерации владельцем сертификата другому лицу (лицам) без передачи сертификата при его погашении',
        id: 85,
    },
    {
        value: 'Внесение записи о передаче атрибутов генерации по двустороннему договору купли-продажи электрической энергии',
        id: 18,
    },
    {
        value: 'Внесение записи об удостоверении (фиксации) атрибутов генерации в иной информационной системе в соответствии с пунктом 7 статьи 41.1 Федерального закона «Об электроэнергетике»',
        id: 79,
    },
    {
        value: 'Услуги по предоставлению доступа к Системе реестра (Открытие лицевого счета / Обслуживание лицевого счета)',
        id: 10,
    },
    {
        value: 'Услуги, связанные с использованием функциональных возможностей Системы реестра (Регистрация ЗГО / Подтверждение статуса ЗГО)',
        id: 71,
    },
]

export const tax = 0.22
